module.exports = __webpack_public_path__ + "assets/approved-green.12b6f1ef.svg";